import * as Linking from 'expo-linking';
import { getStateFromPath as RNGetStateFromPath } from '@react-navigation/native';

//TODO: Add linking configuration for the working application for WEB URLs!
const linking = {
	prefixes: [Linking.createURL('/ow')],
	getStateFromPath(path, options) {
		// Handle /learn route - map it to Auth stack with Learn screen
		// Check if path is exactly /learn or contains /learn
		if (
			typeof path === 'string' &&
			(path === '/learn' || path.includes('/learn'))
		) {
			// Return navigation state that routes to Auth > Learn
			const defaultState = RNGetStateFromPath(path, options);
			if (!defaultState) {
				return {
					routes: [
						{
							name: 'Auth',
							state: {
								routes: [
									{
										name: 'Learn',
										params: { learningMode: true },
									},
								],
							},
						},
					],
				};
			}
			// If default state exists but doesn't have Auth > Learn, modify it
			if (defaultState?.routes?.[0]?.name !== 'Auth') {
				return {
					routes: [
						{
							name: 'Auth',
							state: {
								routes: [
									{
										name: 'Learn',
										params: { learningMode: true },
									},
								],
							},
						},
					],
				};
			}
		}
		// Use default path matching for other routes
		return RNGetStateFromPath(path, options);
	},
	config: {
		screens: {
			Form: 'form/:id',
			LoadingScreen: 'loading-screen',
			UserProfile: 'userprofile/:userId',
			Login: 'login',
			Learn: 'learn',
			Loading: 'loading',
			Registration: 'registration/:productId',
			Auth: {
				path: 'auth',
				screens: {
					Login: 'login',
					Learn: 'learn',
					Registration: 'registration/:productId',
				},
			},
			Dashboard: {
				path: 'dashboard',
				screens: {
					EasyMode: 'easy-mode',
					Community: 'community',
					Welcome: 'welcome',
					Invitations: 'invitations',
					Data: {
						path: 'data',
						screens: {
							Data: 'data',
							Find: 'find',
							Media: 'media',
							Upload: 'upload',
							ActionHandler: 'action-handler/:dataId',
							CreateData: 'create-data',
							ManageData: 'manage-data',
							DataStore: 'data-store',
							DocumentTemplateEditor: 'document-editor/:dataId',
							TimeLineData: 'timeline/:dataId',
							ComponentDesigner: 'component-designer/:dataId',
							DataCreator: 'data-creator',
							DataHandler: 'data-handler',
							DataBrowser: 'data-browser/:requestId/:title',
							DataTemplates: 'data-templates',
							DataMenu: 'data-menu',
							Utilities: 'utilities',
							CreateEmailTemplate: 'create-email-template',
							PublicData: 'public-data',
							WhatsappTemplates: 'whatsapp-templates',
							BubbleScreen: 'data-bubbles',
							PreviewEmailTemplate:
								'preview-email-template/:templateId',
							EmailTemplates: 'email-templates',
							InvoiceTemplates: 'invoice-templates',
							Invoice: 'invoice/:templateId',
							DocumentTemplates: 'document-templates',
							ProductScreen: 'product/:productId',
							CreativeTemplates: 'creative-templates',
							NewCreativeTemplate: 'edit-creative-template',
							InvoiceDetail: 'invoice-detail/:invoiceId',
						},
					},
					Flows: {
						path: 'flows',
						screens: {
							FlowMenu: 'flows',
							ManualFlows: 'manual-flows',
							SalesFlows: 'sales-flows',
							CallFlows: 'call-flows',
							FlowDesigner: 'flow-designer/:flowId/:mode',
							FlowEditor: 'flow-editor/:flowId/:mode',
						},
					},
					Sales: {
						path: 'sales',
						screens: {
							SalesDashboard: 'sales-dash',
							SalesFunnel: 'sales-funnel/:campaignId',
							SalesStats: 'sales-stats/:id',
							SocialPosts: 'social',
							ActiveCampaigns: 'active-campaigns',
							PreviousCampaigns: 'previous-campaigns',
							SalesLeads: 'sales-leads',
							Forecast: 'forecast',
						},
					},
					Projects: {
						path: 'projects',
						screens: {
							ProjectsList: 'project-list',
							IndividualProjectPage: 'project/:projectId/:title',
							ProjectMenu: 'project-menu',
							Templates:'project-templates'
						},
					},
					Reports: {
						path: 'data-reports',
						screens: {
							Reports: 'reports',
							ReportsList: 'reports-list',
							IndividualReportScreen: 'report/:dataId',
							ReportDashboard: 'report-dashboard',
						},
					},
					Calendar: {
						path: 'calendar',
						screens: {
							MainCalendar: 'main-calendar',
							Reminders: 'reminders',
							Meetings: 'meetings',
							Breakdown: 'breakdown',
						},
					},
					Academy: {
						path: 'academy',
						screens: {
							Completed: 'completed',
							Progress: 'progress',
							Courses: 'courses/:id',
							Certifications: 'certifications',
							AcademyMain: 'menu',
							CourseEditor: 'course-editor/:courseId/:mode',
						},
					},
					Users: {
						path: 'users',
						screens: {
							UserList: 'user-list',
							StartupBuilder: 'startup-builder',
							UserActivity: 'user-activity',
							UserManagement: 'user-management',
							CompanySettings: 'company-settings',
							HRManagement: 'hr-management',
							UserMenu: 'user-menu',
							HRDashboard: 'hr-dashboard',
							EmployeeManagement: 'employee-management',
							LeaveManagement: 'leave-management',
							AttendanceManagement: 'attendance-management',
							PayrollManagement: 'payroll-management',
							PerformanceReviews: 'performance-reviews',
						},
					},
					Integrations: 'integrations',
					Settings: {
						path: 'settings',
						screens: {
							Profile: 'profile',
							Achievements: 'achievements',
							Upgrade: 'upgrade',
							API: 'api',
							Context: 'context',
							Credits: 'credits',
							Statistics: 'statistics',
							Affiliate: 'affiliate',
						},
					},
					Knowledge: {
						path: 'knowledge',
						screens: {
							Flows: 'flows',
							ChatBot: 'chat-bot',
							InternalKnowledge: 'internal-knowledge',
							ExternalKnowledge: 'external-knowledge',
							KnowledgeScreen: 'knowledge-screen',
							EditKnowledge: 'edit-knowledge/:knowledgeArticleId',
							JournalEntry: 'journal-entry',
							// FlowMenu: 'flows',
							ManualFlows: 'manual-flows',
							SalesFlows: 'sales-flows',
							CallFlows: 'call-flows',
							FlowDesigner: 'flow-designer',
							FlowEditor: 'flow-editor/:flowId/:mode',
							UserUploadedDocuments: 'user-uploaded-documents',
						},
					},
					Mail: {
						path: 'mail',
						screens: {
							MailLoginScreen: 'login',
							Main: 'mailbox',
						},
					},
					Networking: {
						path: 'networking',
						screens: {
							Map: 'map',
							Profiles: 'profiles',
							Search: 'search',
							Meet: 'meet',
						},
					},
					Help: 'help',
				},
			},
			Store: {
				path: 'store',
				screens: {
					StoreLoading: 'loading-store',
					StoreList: 'store/:storeId',
				},
			},
			NotFound: '404',
		},
	},
	// 		getStateFromPath(path, options) {
	// 			let state = getStateFromPath(path, options);
	// console.log(state)
	// 			// If the state is undefined, it means that the path doesn't match any route in our config, and
	// 			// we want to handle the path ourselves to the right screen, by updating the state and returning it.
	// 			// if (!state) {
	// 			// 	// check if route contains the main identifier of the screen we want to show
	// 			// 	const isTree = path.includes('dashboard');
	// 			// 	if (isTree) {
	// 			// 		const [, , branch, ...rest] = path.split('/');

	// 			// 		state = {
	// 			// 			routes: [
	// 			// 				{
	// 			// 					path,
	// 			// 					name: 'Dashboard',
	// 			// 					params: {
	// 			// 						branch,
	// 			// 						path: rest.join('/'), // here, our path is the rest of the path after the branch
	// 			// 					},
	// 			// 				},
	// 			// 			],
	// 			// 		};
	// 			// 	}
	// 			// }
	// 			return state;
	// 		},
};

export default linking;
